import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogContainerComponent } from './dialog-container.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from 'src/app/angular-material.module';

@NgModule({
  declarations: [
    DialogContainerComponent
  ],
  exports: [
    DialogContainerComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    AngularMaterialModule
  ]
})
export class DialogContainerModule { }
